// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import $ from 'jquery'
import '../static/js/jquery.min.js'
import '../static/css/bootstrap.min.css'
import '../static/css/bootstrap-theme.css'
import '../static/js/bootstrap.min.js'
import '../static/js/swiper.min.js'
import '../static/css/swiper.min.css'
import '../static/css/animate.min.css'
import '../static/js/wow.min.js'
import '../static/css/font-awesome.min.css'
import '../static/css/owl.theme.css'
import '../static/css/owl.carousel.css'
import '../static/css/main.css'
import VueI18n from 'vue-i18n'
import Vue from 'vue'
import App from './App'
import router from './router'

import ecconfig from '@/../static/res/config.js'

// import 'babel-polyfill'
// require('babel-polyfill')
Vue.use(VueI18n)
Vue.config.productionTip = false
var {getLang} = require("./lang.js");
var i18n = new VueI18n ({
    locale:  localStorage.getItem('locale') || getLang(),  //语言标识
    messages: {
        'zh': require('./lang/zh'),
        'en': require('./lang/en')
    }
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    //document.title = to.meta.title
  }else{
    document.title = ecconfig.defaultMetas.title;
  }

  let metaKeywords;
  let metaDescs;
  let metaTags = document.getElementsByTagName('meta');
  if (metaTags){
    for (let i = 0; i < metaTags.length; i++) {
      if (metaTags[i].name == 'Keywords') {
        metaKeywords = metaTags[i];
      }
      if (metaTags[i].name == 'Description') {
        metaDescs = metaTags[i];
      }
    }
  }

  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'Keywords';
    document.head.appendChild(metaKeywords);
  }
  if (!metaDescs) {
    metaDescs = document.createElement('meta');
    metaDescs.name = 'Description';
    document.head.appendChild(metaDescs);
  }

  if (to.meta.keywords){
    metaKeywords.content = to.meta.keywords.join(',');
  } else {
    metaKeywords.content = ecconfig.defaultMetas.keywords;
  }

  if (to.meta.description){
    metaDescs.content = to.meta.description;
  } else {
    metaDescs.content = ecconfig.defaultMetas.description;
  }
  next()
})


new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js